// extracted by mini-css-extract-plugin
module.exports = {"links":"az_I2c"};